module.exports = __webpack_public_path__ + "img/Poorter_hotel-076.223825c0.jpg";